export const I18N_NO_MARKETS = 'no_markets.';
export const I18N_NO_MARKETS_MESSAGE = `${I18N_NO_MARKETS}message`;
export const I18N_NO_MARKETS_BUTTON = `${I18N_NO_MARKETS}button`;
export const NO_MARKETS_BUTTON_LINK = '/';
export const NO_RESULTS_ICON = 'no-results';
